<template>
  <sys-data-table
    v-model="lista_coberturas_selecionadas"
   :headers="cabecalhos"
   :height="altura_janela - 163"
   :item-height="45"
   :items="lista_coberturas"
   show-select
  >
    <template #top>
      <div class="d-flex align-center w-full my-1">
        <v-icon :size="19">mdi-format-list-bulleted</v-icon>
        <span class="ml-1" @click="buscarListaCoberturas">Lista de coberturas</span>

        <v-spacer />

        <AplicarCoberturas
          v-if="lista_coberturas_selecionadas.length"
          :coberturas="lista_coberturas_selecionadas"
          content_class="mr-4"
          @coberturas-aplicadas="lista_coberturas_selecionadas = []"
        />

        <Cadastro
          :disabled="lista_coberturas_para_edicao.length === 0"
          :coberturas="lista_coberturas_para_edicao"
          @atualizacao-parametrizacao="buscarListaCoberturas"
        />
      </div>
    </template>

    <template #item.acoes="{ item }">
      <div class="d-flex align-center">
        <AplicarCoberturas
          :coberturas="[item]"
          content_class="mr-4"
        >
          <template #ativador="{ callback }">
            <v-btn icon @click="callback">
              <v-icon>mdi-playlist-check</v-icon>
            </v-btn>
          </template>
        </AplicarCoberturas>

        <TabelaProdutos
          :curva_pqr="item.pqr"
          :curva_xyz="item.xyz"
        />

        <Cadastro
          :coberturas="lista_coberturas_para_edicao"
          @atualizacao-parametrizacao="buscarListaCoberturas"
        >
          <template #ativador="{ callback }">
            <v-btn icon @click="callback">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </Cadastro>
      </div>
    </template>
  </sys-data-table>
</template>

<script setup>
import Cadastro from "@/components/compra/Coberturas/CoberturaEsegPorLocalidade/Cadastro.vue";
import {onMounted, ref} from "vue";
import {useResize} from "@/helpers/Resize";
import store from "@/store";
import * as req from "@/api/compras/CoberturaEsegPorLocalidade.js";
import {logout} from "@/helpers";
import TabelaProdutos from "@/components/compra/Coberturas/CoberturaEsegPorLocalidade/TabelaProdutos.vue";
import AplicarCoberturas from "@/components/compra/Coberturas/CoberturaEsegPorLocalidade/AplicarCoberturas.vue";

const {altura_janela} = useResize();

const cabecalhos = [
  { text: 'Frequência', value: 'descricao_pqr' },
  { text: 'Faturamento', value: 'descricao_xyz' },
  { text: 'Local', value: 'tempo_cobertura_esseg_local', is_number: true, sufix: 'dias' },
  { text: 'Nacional', value: 'tempo_cobertura_esseg_nacional', is_number: true, sufix: 'dias' },
  { text: 'Importado', value: 'tempo_cobertura_esseg_importado', is_number: true, sufix: 'dias' },
  { text: 'Ações', value: 'acoes', style: { width: '90px' } },
];

const lista_coberturas = ref([]);
const lista_coberturas_para_edicao = ref([]);
const lista_coberturas_selecionadas = ref([]);

onMounted(buscarListaCoberturas);

function buscarListaCoberturas() {
  lista_coberturas.value = [];
  lista_coberturas_para_edicao.value = [];

  store.dispatch('loading/addRequisicao',
    req.buscarListaCoberturas()
      .then(coberturas => {
        lista_coberturas.value = coberturas;
        lista_coberturas_para_edicao.value = coberturas.map(item => Object.assign({}, item));
      })
      .catch(logout)
  );
}
</script>

<style scoped>

</style>
